import {selectDomain} from '.';
import {createSelector} from '@reduxjs/toolkit';

export default createSelector([selectDomain], state => state.currentSituation);
